import React, { Fragment, useCallback, useState } from "react";
import { Skeleton } from "@material-ui/lab";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { isBlank, notBlank } from "../util/ext";
import { equals, any } from "ramda";
import TextField from "@material-ui/core/TextField";

// import { identity } from "rxjs";

const ModuleAutoComplete = props => {
  const {
    onChange,
    label = "Module",
    // filterFunction = identity,
    modules,
    disabledModules,
  } = props;

  const [selectedModule, setSelectedModule] = useState(null);

  // const filterFunctionCallback = useCallback(filterFunction);

  const handleModuleSelect = useCallback(
    (_event, module) => {
      setSelectedModule(module);
      onChange(_event, module ? module : null);
    },
    [onChange],
  );

  return (
    <Fragment>
      {modules.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <Autocomplete
          //   multiple
          //   autoSelect
          options={modules}
          value={selectedModule || ""}
          clearOnBlur={false}
          getOptionLabel={module => {
            return notBlank(module) ? module.moduleName : "";
          }}
          getOptionSelected={(opt, val) => {
            return isBlank(val) || equals(opt.moduleId, val.moduleId);
          }}
          getOptionDisabled={opt => {
            return any(module => equals(module.moduleId, opt.moduleId))(
              disabledModules,
            );
          }}
          onChange={handleModuleSelect}
          renderInput={params => {
            params.inputProps["aria-autocomplete"] = "none";
            params.inputProps["id"] = null;
            return (
              <TextField
                {...params}
                type="text"
                name={"module-" + Math.random()}
                variant="standard"
                label={label}
              />
            );
          }}
        />
      )}
    </Fragment>
  );
};

export default ModuleAutoComplete;
